import { render, staticRenderFns } from "./sendRequest.vue?vue&type=template&id=3b6cc251&scoped=true&"
import script from "./sendRequest.vue?vue&type=script&lang=js&"
export * from "./sendRequest.vue?vue&type=script&lang=js&"
import style0 from "./sendRequest.vue?vue&type=style&index=0&id=3b6cc251&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cc251",
  null
  
)

export default component.exports